module.exports = __webpack_public_path__ + "img/27.1.86b94633.jpg";